import { Icon, ICONS } from 'components/Icon';
import { IconButton } from 'components/IconButton';
import { ModalScreens } from 'components/Navigation/types';
import { Txt } from 'components/Txt';
import { BlurView } from 'expo-blur';
import { useSelector } from 'hooks/useSelector';
import { pluralise } from 'lib/pluralise';
import { theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL } from 'store/actions';
import {
  selectAseIsEditable,
  selectAseExplorerOptions,
  selectAseResultsCount,
  selectAseActionCountAse,
  selectAseControlCountAse,
} from 'store/assessments/selectors';

export const ExplorerQuestionsHeader: React.FC = () => {
  const dispatch = useDispatch();
  const isEditable = useSelector(selectAseIsEditable);
  const {
    checklistsCount,
    completedChecklistsCount,
    questionsCount,
    completedQuestionsCount,
  } = useSelector(selectAseResultsCount);
  const actionsCount = useSelector(selectAseActionCountAse);
  const controlsCount = useSelector(selectAseControlCountAse);
  const explorerOptions = useSelector(selectAseExplorerOptions);

  const hasEnabledFilterOptions =
    !explorerOptions.findingsNewReviewed ||
    !explorerOptions.questionsNegative ||
    !explorerOptions.questionsPositive ||
    (isEditable &&
      (!explorerOptions.questionsUnanswered ||
        !explorerOptions.findingsUnreviewed));

  return (
    <BlurView
      intensity={10}
      style={{
        marginHorizontal: theme.paddingHorizontal,
        marginTop: theme.paddingPageVertical,
        height: 50,
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'stretch',
        justifyContent: 'space-around',
        borderRadius: 8,
        overflow: 'hidden',
      }}
    >
      {!!questionsCount && (
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            backgroundColor: theme.colors.question,
            alignItems: 'center',
            justifyContent: 'center',
            paddingVertical: theme.paddingHorizontal / 2,
          }}
        >
          <Icon source={ICONS.CircleQSolid} color={theme.colors.white} />
          <Txt
            size="xxxsmall"
            weight="bold"
            style={{
              color: theme.colors.white,
              marginLeft: theme.paddingHorizontal / 2,
            }}
          >
            {isEditable && completedQuestionsCount !== questionsCount
              ? `${completedQuestionsCount.toString()}/${questionsCount.toString()}`
              : `${completedQuestionsCount} `}
          </Txt>
        </View>
      )}
      {!!checklistsCount && (
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            backgroundColor: theme.colors.checklist,
            alignItems: 'center',
            justifyContent: 'center',
            paddingVertical: theme.paddingHorizontal / 2,
          }}
        >
          <Icon source={ICONS.CircleCSolid} color={theme.colors.white} />
          <Txt
            size="xxxsmall"
            weight="bold"
            style={{
              color: theme.colors.white,
              marginLeft: theme.paddingHorizontal / 2,
            }}
          >
            {isEditable && completedChecklistsCount !== checklistsCount
              ? `${completedChecklistsCount.toString()}/${checklistsCount.toString()}`
              : `${completedChecklistsCount} `}
          </Txt>
        </View>
      )}
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          backgroundColor: theme.colors.assessmentAction,
          alignItems: 'center',
          justifyContent: 'center',
          paddingVertical: theme.paddingHorizontal / 2,
          paddingHorizontal: theme.paddingHorizontal / 2,
        }}
      >
        <Txt
          size="xsmall"
          weight="bold"
          style={{
            color: theme.colors.white,
            flex: 1,
            textAlign: 'center',
          }}
          numberOfLines={1}
        >
          {pluralise(actionsCount, '1 Action', '{x} Actions', 'No Actions')}
        </Txt>
      </View>
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          backgroundColor: theme.colors.assessmentControl,
          alignItems: 'center',
          justifyContent: 'center',
          paddingVertical: theme.paddingHorizontal / 2,
          paddingHorizontal: theme.paddingHorizontal / 2,
        }}
      >
        <Txt
          size="xsmall"
          weight="bold"
          style={{
            color: theme.colors.white,
            flex: 1,
            textAlign: 'center',
          }}
          numberOfLines={1}
        >
          {pluralise(controlsCount, '1 Control', '{x} Controls', 'No Controls')}
        </Txt>
      </View>
      <View
        style={{
          backgroundColor: theme.colors.blue20,
          justifyContent: 'center',
          padding: theme.paddingHorizontal / 2,
          flexDirection: 'row',
        }}
      >
        <IconButton
          icon={ICONS.SlidersUpLight}
          onPress={() =>
            dispatch(
              NAVIGATE_MODAL({
                screen: ModalScreens.ASEEXPLOREROPTIONS,
                params: {},
              }),
            )
          }
          showBadge={hasEnabledFilterOptions}
        />
      </View>
      {/* <Button
        icon={ICONS.SlidersUpLight}
        onPress={() =>
          dispatch(
            NAVIGATE_MODAL({
              screen: ModalScreens.ASEEXPLOREROPTIONS,
              params: {},
            }),
          )
        }
        showBadge={hasEnabledFilterOptions}
        style={{
          borderRadius: 0,
          height: '100%',
          borderLeftColor: theme.colors.background,
          borderLeftWidth: 1,
        }}
      /> */}
    </BlurView>
  );
};
